import React from "react"
export function FlexiflyIcon(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <defs>
        <filter
          x="-2.3%"
          y="-2.6%"
          width="104.5%"
          height="104.7%"
          filterUnits="objectBoundingBox"
          id="prefix__filter-4"
        >
          <feOffset dy={-1} in="SourceAlpha" result="shadowOffsetInner1" />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
            result="shadowInnerInner1"
          />
          <feColorMatrix
            values="0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0 0.129411765 0 0 0 0.116559222 0"
            in="shadowInnerInner1"
          />
        </filter>
        <filter
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
          id="prefix__filter-7"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.112447732 0 0 0 0 0.470504982 0 0 0 0 0 0 0 0 1 0"
            in="shadowOffsetOuter1"
          />
        </filter>
        <path
          d="M.312 2.997C-1.133 12.224 2.44 19.225 11.027 24c8.356-4.394 11.94-11.395 10.75-21.003l-3.655-1.624a17.442 17.442 0 00-14.168.004L.312 2.997z"
          id="prefix__ff-icon-path-2"
        />
        <path
          d="M13.28 1.377l-3.145 2.846L3.427 3.5l-.972 1.087 5.21 1.871L.945 13.07l.913 1.043 7.347-5.937 1.929 6.101.99-1.067-.45-7.27 3.259-2.949c1.038-1.028-.627-2.628-1.652-1.613z"
          id="prefix__ff-icon-path-5"
        />
        <linearGradient
          x1="50%"
          y1="-6.44%"
          x2="50%"
          y2="113.78%"
          id="prefix__ff-icon-linearGradient"
        >
          <stop stopColor="#89D500" offset="0%" />
          <stop stopColor="#43A200" offset="100%" />
        </linearGradient>
      </defs>
      <g
        id="prefix__FF-Icon-Color"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__FF">
          <g
            id="prefix__ff-icon-Mask-+-Combined-Shape-Mask"
            transform="translate(.97)"
          >
            <mask id="prefix__ff-icon-mask-3" fill="#fff">
              <use xlinkHref="#prefix__ff-icon-path-2" />
            </mask>
            <g id="prefix__ff-icon-Mask">
              <use
                fill="url(#prefix__ff-icon-linearGradient)"
                xlinkHref="#prefix__ff-icon-path-2"
              />
              <use
                fill="#000"
                filter="url(#prefix__filter-4)"
                xlinkHref="#prefix__ff-icon-path-2"
              />
            </g>
            <g
              id="prefix__ff-icon-Path-20-Copy"
              mask="url(#prefix__ff-icon-mask-3)"
            >
              <g transform="translate(1.655 3.72)">
                <mask id="prefix__ff-icon-mask-6" fill="#fff">
                  <use xlinkHref="#prefix__ff-icon-path-5" />
                </mask>
                <g
                  id="prefix__ff-icon-Mask-1"
                  stroke="none"
                  fill="none"
                  transform="rotate(9 8.102 7.664)"
                >
                  <use
                    fill="#000"
                    filter="url(#prefix__filter-7)"
                    xlinkHref="#prefix__ff-icon-path-5"
                  />
                  <use fill="#FFF" xlinkHref="#prefix__ff-icon-path-5" />
                </g>
                <path
                  d="M.942 11.235c.12.188.264.407.43.654.167.248.363.522.59.823l-1.02.58c-.23-.414-.392-.7-.485-.86-.092-.16-.206-.368-.34-.625l.825-.572z"
                  id="prefix__ff-icon-Path-20-Copy"
                  stroke="none"
                  fill="#E8E8E8"
                  fillRule="evenodd"
                  mask="url(#prefix__ff-icon-mask-6)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
